import React, {FC} from 'react';
import styled from 'styled-components';

interface NewsletterLandingPageProps {
  title: string;
}

export const NewsletterLandingPage: FC<
  React.PropsWithChildren<NewsletterLandingPageProps>
> = ({title, children}) => {
  return (
    <PageWrapper>
      <Wrapper>
        <Header>{title}</Header>
        {children}
      </Wrapper>
    </PageWrapper>
  );
};

const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f4f5;
  height: calc(100vh - (120px + 80px));
`;

const Wrapper = styled.div`
  height: fit-content;
  padding: 40px;
  width: 470px;
  background-color: #fff;
`;

const Header = styled.h2`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.15;
  margin-bottom: 30px;
`;
